import { SyncWalletResponse } from "@syla/shared/types/responses/SyncWalletResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function syncWallet(
  accountId: string,
  walletId: string,
  fromDate?: Date,
) {
  try {
    const result = await axios.post<SyncWalletResponse>(
      `/accounts/${accountId}/wallets/sync/${walletId}`,
      {
        fromDate,
      },
    );
    return result.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
